// src/assets/data/ValidationTemplates/validationTemplates.js

// ── Validation templates ──────────────────────────────────────────────
export const validationTemplateNames = [
    "Generic Model Validation Report (MVR)",
    "SR 11-7 — Model Validation Template (US Banking)",
    "ECB/EBA TRIM — Validation Template (EU Banking)",
    "NIST AI RMF — Risk-based Validation Template",
    "FDA SaMD — AI/ML Validation Template (Medical)",
    "Basel/BIS — Banking Model Validation Template",
    "ISO/IEC AI — Standards-based Validation Template",
    "Internal Checklist / Scorecard Validation Template",
];

const VALIDATION_FILE_MAP = {
    "Generic Model Validation Report (MVR)": "generic-mvr.md",
    "SR 11-7 — Model Validation Template (US Banking)": "sr-11-7-validation.md",
    "ECB/EBA TRIM — Validation Template (EU Banking)": "ecb-eba-trim-validation.md",
    "NIST AI RMF — Risk-based Validation Template": "nist-aimrf-validation.md",
    "FDA SaMD — AI/ML Validation Template (Medical)": "fda-samd-validation.md",
    "Basel/BIS — Banking Model Validation Template": "basel-bis-validation.md",
    "ISO/IEC AI — Standards-based Validation Template": "iso-iec-ai-validation.md",
    "Internal Checklist / Scorecard Validation Template": "internal-checklist-validation.md",
};

export async function fetchValidationMd(templateName) {
    const file = VALIDATION_FILE_MAP[templateName];
    if (!file) {
        throw new Error(`Unknown validation template: ${templateName}`);
    }
    const base = "/data/ModelValidationTemplates";
    const url = `${base}/${file}`;
    const res = await fetch(url, { cache: "no-cache" });
    if (!res.ok) throw new Error(`Failed to load ${file} (${res.status})`);
    return res.text();
}
